import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Chapter } from "./Reveal";
import Countdown from "./Countdown";
import { IMAGES, scrollToSection } from "./constants";

const MONTHS = ["Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"];

const Availability = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="season"
      ref={ref}
      data-testid="season-section"
      className="relative overflow-hidden bg-ebony py-32 lg:py-44"
    >
      <motion.img
        src={IMAGES.piaffe}
        alt="Dressage rider performing piaffe, fine-art black and white"
        data-testid="season-image"
        style={{ y: imgY }}
        className="absolute inset-0 h-[124%] w-full object-cover object-center opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ebony via-ebony/60 to-ebony" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center lg:px-10">
        <Reveal className="flex justify-center">
          <Chapter number="04" title="The Season" testId="season-chapter" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif text-5xl font-light leading-none tracking-tight text-offwhite md:text-7xl">
            October <em className="italic text-gold">—</em> May
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-8 max-w-xl text-base font-light leading-relaxed text-cream/70 md:text-lg">
            Dubai's riding season is short, and Kiara accepts a limited number
            of horses each winter. Training runs strictly from October through
            May — when the season ends, training pauses until the autumn.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-wrap justify-center gap-2.5">
            {MONTHS.map((m) => (
              <span
                key={m}
                data-testid={`month-pill-${m.toLowerCase()}`}
                className="border border-champagne/30 px-5 py-2 text-xs uppercase tracking-[0.25em] text-cream/70 transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                {m}
              </span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.35} className="flex justify-center">
          <Countdown />
        </Reveal>
        <Reveal delay={0.4}>
          <p className="mt-10 text-xs uppercase tracking-[0.3em] text-champagne">
            Seasonal slots are limited — reserve early
          </p>
          <button
            data-testid="season-reserve-button"
            onClick={() => scrollToSection("#consultation")}
            className="mt-8 border border-gold bg-gold px-10 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-ebony transition-colors duration-500 hover:bg-transparent hover:text-gold"
          >
            Reserve Winter Training
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export default Availability;
